import React from 'react';
import { Square, Hexagon, MousePointer } from 'lucide-react';
import { useMapStore } from '../stores/useMapStore';
import { Tooltip } from './Tooltip';
import type { SelectionMode } from '../stores/useMapStore';

const MODES: { id: SelectionMode; label: string; icon: React.ReactNode }[] = [
  { id: 'bbox', label: 'Box', icon: <Square className="h-3.5 w-3.5" /> },
  { id: 'polygon', label: 'Polygon', icon: <Hexagon className="h-3.5 w-3.5" /> },
  { id: 'none', label: 'Pan', icon: <MousePointer className="h-3.5 w-3.5" /> },
];

export const SelectionModeToggle: React.FC = React.memo(() => {
  const selectionMode = useMapStore((s) => s.selectionMode);
  const setSelectionMode = useMapStore((s) => s.setSelectionMode);
  const setPolygonVertices = useMapStore((s) => s.setPolygonVertices);

  const handleModeChange = (mode: SelectionMode) => {
    setSelectionMode(mode);
    if (mode !== 'polygon') {
      setPolygonVertices([]);
    }
  };

  return (
    <div className="flex items-center gap-1 rounded-lg bg-slate-800/90 p-1 backdrop-blur-sm border border-slate-600/50 shadow-lg">
      {MODES.map((mode) => (
        <Tooltip key={mode.id} label={mode.label} position="bottom">
          <button
            onClick={() => handleModeChange(mode.id)}
            className={[
              'flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium transition-colors min-h-touch',
              selectionMode === mode.id
                ? 'bg-sky-900/40 text-sky-300'
                : 'text-slate-400 hover:text-slate-200 hover:bg-slate-700/50',
            ].join(' ')}
            aria-pressed={selectionMode === mode.id}
          >
            {mode.icon}
            <span className="hidden sm:inline">{mode.label}</span>
          </button>
        </Tooltip>
      ))}
    </div>
  );
});
